var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { ref, watch } from "vue";
import {} from "@/api/remoteFiles";
import { useFileSources } from "@/composables/fileSources";
import DOILink from "./DOILink.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportRecordDOILink',
    props: {
        exportRecordUri: null,
        rdmFileSources: null
    },
    setup(__props) {
        const props = __props;
        const { getFileSourceByUri, isLoading: isLoadingFileSources } = useFileSources({ include: ["rdm"] });
        const doi = ref(undefined);
        // File sources need to be loaded before we can get the DOI
        watch(isLoadingFileSources, (isLoading) => __awaiter(this, void 0, void 0, function* () {
            if (!isLoading) {
                doi.value = yield getDOIFromExportRecordUri(props.exportRecordUri);
            }
        }));
        /**
         * Gets the DOI from an export record URI.
         * The URI should be in the format: `<scheme>://<source-id>/<record-id>/<file-name>`.
         * @param uri The target URI of the export record to get the DOI from.
         * @returns The DOI or undefined if it could not be retrieved.
         */
        function getDOIFromExportRecordUri(uri) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!uri) {
                    return undefined;
                }
                const fileSource = getFileSourceByUri(uri);
                if (!fileSource) {
                    console.debug("No file source found for URI: ", uri);
                    return undefined;
                }
                const repositoryUrl = fileSource.url;
                if (!repositoryUrl) {
                    console.debug("Invalid repository URL for file source: ", fileSource);
                    return undefined;
                }
                const recordId = getRecordIdFromUri(uri);
                if (!recordId) {
                    console.debug("No record ID found for URI: ", uri);
                    return undefined;
                }
                const recordUrl = `${repositoryUrl}/api/records/${recordId}`;
                return getDOIFromInvenioRecordUrl(recordUrl);
            });
        }
        /**
         * Extracts the record ID from a URI.
         * The URI should be in the format: `<scheme>://<source-id>/<record-id>/<file-name>`.
         * @param targetUri The URI to extract the record ID from.
         * @returns The record ID or undefined if it could not be extracted.
         */
        function getRecordIdFromUri(targetUri) {
            var _a;
            if (!targetUri) {
                return undefined;
            }
            return (_a = targetUri.split("//")[1]) === null || _a === void 0 ? void 0 : _a.split("/")[1];
        }
        /**
         * Gets the DOI from an Invenio record URL.
         * @param recordUrl The URL of the record to get the DOI from.
         * @returns The DOI or undefined if it could not be retrieved.
         */
        function getDOIFromInvenioRecordUrl(recordUrl) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!recordUrl) {
                    return undefined;
                }
                try {
                    const response = yield axios.get(recordUrl);
                    if (response.status !== 200) {
                        console.debug("Failed to get record from URL: ", recordUrl);
                        return undefined;
                    }
                    const record = response.data;
                    if (!(record === null || record === void 0 ? void 0 : record.doi)) {
                        console.debug("No DOI found in record: ", record);
                        return undefined;
                    }
                    return record.doi;
                }
                catch (error) {
                    console.warn("Failed to get record from URL: ", recordUrl, error);
                    return undefined;
                }
            });
        }
        return { __sfc: true, getFileSourceByUri, isLoadingFileSources, props, doi, getDOIFromExportRecordUri, getRecordIdFromUri, getDOIFromInvenioRecordUrl, DOILink };
    }
});
